<p-fieldset legend="Informações do Registro de Preço" [toggleable]="entidade.id" [collapsed]="entidade.armazenado">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="dados-iniciais-tab" data-toggle="tab" href="#dados-iniciais" role="tab"
        aria-controls="dados-iniciais" aria-selected="true">Dados Iniciais</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="dados-adicionais-tab" data-toggle="tab" href="#dados-adicionais" role="tab"
        aria-controls="dados-adicionais" aria-selected="true">Dados Adicionais</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && (arquivo.modalidade === 1 || arquivo.modalidade === 2)">
      <a class="nav-link" id="pre-qualificacao-tab" data-toggle="tab" href="#pre-qualificacao" role="tab"
        aria-controls="pre-qualificacao" aria-selected="true">Pré-qualificação</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="lote-item-tab" data-toggle="tab" href="#lote-item" role="tab" aria-controls="lote-item"
        aria-selected="true">Lote/Item</a>
    </li>
    <li class="nav-item" *ngIf="arquivo.modalidade === 10 || arquivo.modalidade === 11">
      <a class="nav-link" id="ratificacao-tab" data-toggle="tab" href="#ratificacao" role="tab"
        aria-controls="ratificacao" aria-selected="true">Ratificação</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="declaracao-recursos-tab" data-toggle="tab" href="#declaracao-recursos" role="tab"
        aria-controls="declaracao-recursos" aria-selected="true">Declaração Recursos</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="lrf-tab" data-toggle="tab" href="#lrf" role="tab" aria-controls="lrf"
        aria-selected="true">LRF</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="parecer-tab" data-toggle="tab" href="#parecer" role="tab" aria-controls="parecer"
        aria-selected="true">Parecer Técnico</a>
    </li>
    <li class="nav-item"
      *ngIf="registroPreco === 'N' && arquivo.modalidade !== 2 && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="edital-tab" data-toggle="tab" href="#edital" role="tab" aria-controls="edital"
        aria-selected="true">Edital</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade === 2">
      <a class="nav-link" id="edital-fase2-tab" data-toggle="tab" href="#edital-fase2" role="tab"
        aria-controls="edital-fase2" aria-selected="true">Edital 2a Fase</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="datas-tab" data-toggle="tab" href="#datas" role="tab" aria-controls="datas"
        aria-selected="true">Datas</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="comissao-tab" data-toggle="tab" href="#comissao" role="tab" aria-controls="comissao"
        aria-selected="true">Comissão</a>
    </li>
    <li class="nav-item" *ngIf="arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="licitantes-tab" data-toggle="tab" href="#licitantes" role="tab" aria-controls="licitantes"
        aria-selected="true">Licitantes</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="atestado-tab" data-toggle="tab" href="#atestado" role="tab" aria-controls="atestado"
        aria-selected="true">Atestados</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="indice-tab" data-toggle="tab" href="#indice" role="tab" aria-controls="indice"
        aria-selected="true">Índices</a>
    </li>
    <li class="nav-item">
      <a *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO' || arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'" class="nav-link"
        id="amostras-tab" data-toggle="tab" href="#amostras" role="tab" aria-controls="amostras"
        aria-selected="true">Amostras</a>
      <a *ngIf="arquivo.tipoObjeto === 'ENGENHARIA'" class="nav-link" id="visita-tab" data-toggle="tab" href="#visita"
        role="tab" aria-controls="visita" aria-selected="true">Visita técnica</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="tributos-tab" data-toggle="tab" href="#tributos" role="tab" aria-controls="tributos"
        aria-selected="true">Tributos</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="julgamento-tab" data-toggle="tab" href="#julgamento" role="tab" aria-controls="julgamento"
        aria-selected="true" *ngIf="arquivo.modalidade !== 2">Julgamento/Recursos</a>
      <a class="nav-link" id="julgamento-tab" data-toggle="tab" href="#julgamento" role="tab" aria-controls="julgamento"
        aria-selected="true" *ngIf="arquivo.modalidade === 2">Ata de Recebimento e Julgamento</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="homologacao-tab" data-toggle="tab" href="#homologacao" role="tab"
        aria-controls="homologacao" aria-selected="true">Homologação</a>
    </li>
    <li class="nav-item" *ngIf="registroPreco === 'N' && arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
      <a class="nav-link" id="adjudicacao-tab" data-toggle="tab" href="#adjudicacao" role="tab"
        aria-controls="adjudicacao" aria-selected="true">Adjudicação</a>
    </li>
    <li class="nav-item" *ngIf="arquivo.modalidade === 10 || arquivo.modalidade === 11">
      <a class="nav-link" id="contratacao-direta-tab" data-toggle="tab" href="#contratacao-direta" role="tab"
        aria-controls="contratacao-direta" aria-selected="true">Contratação Direta</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="autorizacao-tab" data-toggle="tab" href="#autorizacao" role="tab"
        aria-controls="autorizacao" aria-selected="true">Autorização</a>
    </li>
  </ul>
  <div class="tab-content">
    <div class="tab-pane fade show active" id="dados-iniciais" role="tabpanel" aria-labelledby="dados-iniciais-tab">
      <p-fieldset legend="Informações sobre o processo">
        <div class="row">
          <div class="col-md-3">
            <label for="codigoLicitacao" class="required">Código da Licitação</label>
            <input type="text" class="form-control" id="codigoLicitacao" [(ngModel)]="arquivo.CodigoLicitacao"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd"
              [style]="{ width: 'calc(100% - 42px)', float: 'left' }">
            <button class="btn btn-outline-secondary float-right" type="button" (click)="atribuirCodigo()"
              style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;"
              *ngIf="!entidade.enviado && !entidade.armazenado">
              <i class="fa fa-sync"></i>
            </button>
          </div>
          <div class="col-md-3">
            <label for="numeroProcessoAdm" class="required d-block">Processo Adm. / Ano</label>
            <div class="col-md-8 p-0 float-left">
              <input type="text" class="form-control" id="numeroProcessoAdm" [(ngModel)]="arquivo.NumeroProcessoAdm"
                [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
            </div>
            <div class="col-md-4 p-0 float-left">
              <input type="text" class="form-control" [(ngModel)]="arquivo.AnoProcessoAdm"
                [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
            </div>
          </div>
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Possui órgãos participantes e os ajustes poderão ser realizados por esses órgãos?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.LicitacaoPossuiParticipantes" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset legend="Ata de Registro de Preço" *ngIf="registroPreco === 'S'">
        <div class="row mb-3">
          <div class="col-md-3">
            <label for="numAtaRegPreco" class="required">Nº Ata</label>
            <input type="text" class="form-control" id="numAtaRegPreco" [(ngModel)]="arquivo.NumAtaRegPreco"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
          <div class="col-md-3">
            <label for="numeroLicitacao" class="required">Nº licitação</label>
            <input type="text" class="form-control" id="numeroLicitacao" [(ngModel)]="arquivo.NumeroLicitacao"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
          <div class="col-md-3">
            <label for="dtAtaRegPreco" class="required d-block">Data da ata</label>
            <p-calendar (onFocus)="onFocusDate()" id="dtAtaRegPreco" [(ngModel)]="arquivo.DtAtaRegPreco"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
          <div class="col-md-3">
            <label for="dtAutorizacao" class="required d-block">Data Autorização</label>
            <p-calendar (onFocus)="onFocusDate()" id="dtAutorizacao" [(ngModel)]="arquivo.DtAutorizacao"
              [ngModelOptions]="{standalone: true}" inputStyleClass="form-control" dataType="string"
              dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
            </p-calendar>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="nomeDetentor" class="required">Nome do órgão detentor da ata</label>
            <input type="text" class="form-control" id="nomeDetentor" [(ngModel)]="arquivo.NomeDetentor"
              [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-md-3">
            <label for="validade" class="required">Validade da ata (meses)</label>
            <input type="text" class="form-control" id="validade" [(ngModel)]="arquivo.Validade"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
          </div>
        </div>
      </p-fieldset>
      <p-fieldset legend="Modalidade" *ngIf="registroPreco === 'N'">
        <div class="row">
          <div class="col-md-6">
            <label for="modalidade" class="required">Modalidade da Licitação</label>
            <select [compareWith]="compareFn" id="modalidade" class="form-control" [(ngModel)]="arquivo.modalidade"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesModalidade" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-6" *ngIf="arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                A licitação é regida pela Lei Estadual nº 13.121/2008, com inversão das fases de proposta e habilitação?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.Lei13121" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
          <div class="col-md-6" *ngIf="arquivo.modalidade !== 4 && arquivo.modalidade !== 7">
            <label for="naturezaLicitacao" class="required">Natureza da Licitação</label>
            <select [compareWith]="compareFn" id="naturezaLicitacao" class="form-control"
              [(ngModel)]="arquivo.NaturezaLicitacao" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesNatureza" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-3" *ngIf="arquivo.modalidade === 13">
            <label for="ModalidadeLicitacaoOutros" class="required">Descrição da Modalidade</label>
            <input type="text" class="form-control" id="ModalidadeLicitacaoOutros"
              [(ngModel)]="arquivo.ModalidadeLicitacaoOutros" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-md-3">
            <label for="NumeroLicitacao" class="required d-block">Nº Licitação / Ano</label>
            <div class="col-md-8 p-0 float-left">
              <input type="text" class="form-control" id="NumeroLicitacao" [(ngModel)]="arquivo.NumeroLicitacao"
                [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
            </div>
            <div class="col-md-4 p-0 float-left">
              <input type="text" class="form-control" [(ngModel)]="arquivo.AnoLicitacao"
                [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskQtd">
            </div>
          </div>
        </div>
        <div class="row mt-2" *ngIf="arquivo.modalidade === 2">
          <div class="col-12">
            <div class="row col-form-label">
              <label class="required float-left col-10">
                Tratando-se de concorrência internacional, há recursos do Banco Interamericano de Desenvolvimento - BID
                -
                envolvidos?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-2"
                [(ngModel)]="arquivo.BIDNao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="arquivo.modalidade === 2 && arquivo.BIDNao === 'S'">
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve Objeção do BID ao aviso de abertura da pré-qualificação?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDObjecaoAvisoAberturaPreQualificacao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve objeção do BID ao Edital da fase de Pré-qualificação?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDEditalFasePreQualificacao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve objeção do BID ao julgamento da fase de Pré-qualificação?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDJulgamentoFasePreQualificacao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve objeção do BID ao Edital da 2a. Fase?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDEdital2aFase" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve objeção do BID ao julgamento das propostas técnicas comerciais?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDJulgamentoPropostasTecnicasComerciais" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Houve objeção do BID ao julgamento da negociação final?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.BIDJulgamentoNegociacaoFinal" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset legend="Divisão do Objeto">
        <div class="row mb-3">
          <div class="col-md-3">
            <label for="divisaoLotes" class="required">Divisão de Lotes</label>
            <select [compareWith]="compareFn" id="divisaoLotes" class="form-control" [(ngModel)]="arquivo.divisaoLotes"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesDivisaoLotes" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="tipoObjeto" class="required">Tipo de Objeto</label>
            <select [compareWith]="compareFn" id="tipoObjeto" class="form-control" [(ngModel)]="arquivo.tipoObjeto"
              [ngModelOptions]="{standalone: true}" (change)="carregarObjetosLicitacao()">
              <option *ngFor="let item of opcoesTipoObjeto" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="objetoLicitacao" class="required">Objeto da Licitação</label>
            <select [compareWith]="compareFn" id="objetoLicitacao" class="form-control"
              [(ngModel)]="arquivo.ComprasServicos.ObjetoLicitacao" [ngModelOptions]="{standalone: true}"
              *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO'">
              <option *ngFor="let item of opcoesObjeto" [ngValue]="item.id">{{item.nome}}</option>
            </select>
            <select [compareWith]="compareFn" id="objetoLicitacao" class="form-control"
              [(ngModel)]="arquivo.ComprasServicosTI.ObjetoLicitacaoTI" [ngModelOptions]="{standalone: true}"
              *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'">
              <option *ngFor="let item of opcoesObjeto" [ngValue]="item.id">{{item.nome}}</option>
            </select>
            <select [compareWith]="compareFn" id="objetoLicitacao" class="form-control"
              [(ngModel)]="arquivo.ObrasServicosEngenharia.ObjetoLicitacaoEN" [ngModelOptions]="{standalone: true}"
              *ngIf="arquivo.tipoObjeto === 'ENGENHARIA'">
              <option *ngFor="let item of opcoesObjeto" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <label for="descricaoObjeto" class="required">Descrição do Objeto</label>
            <textarea class="form-control" id="descricaoObjeto" rows="5" [(ngModel)]="arquivo.DescricaoObjeto"
              [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div class="col-12">
            <label for="justificativaContratacao">Justificativa da Contratação</label>
            <textarea class="form-control" id="justificativaContratacao" rows="5"
              [(ngModel)]="arquivo.JustificativaContratacao" [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div class="col-3" *ngIf="registroPreco === 'N' && arquivo.NaturezaLicitacao !== 2">
            <label for="TotalLicitacaoValor" class="required">Valor total estimado da licitação</label>
            <input type="text" class="form-control" id="TotalLicitacaoValor" [(ngModel)]="arquivo.TotalLicitacaoValor"
              [ngModelOptions]="{standalone: true}" unmask="typed" [imask]="imaskConfig">
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="dados-adicionais" role="tabpanel" aria-labelledby="dados-adicionais-tab">
      <p-fieldset legend="Dados Adicionais">
        <div class="row" *ngIf="arquivo.modalidade !== 10 && arquivo.modalidade !== 11">
          <div class="col-md-6">
            <label for="tipoLicitacao" class="required">Tipo de Licitação</label>
            <select [compareWith]="compareFn" id="tipoLicitacao" class="form-control"
              [(ngModel)]="arquivo.TipoLicitacao" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesTipoLicitacao" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="beneficioLei1232006" class="required">Benefício da LC 123/2006</label>
            <select [compareWith]="compareFn" id="beneficioLei1232006" class="form-control"
              [(ngModel)]="arquivo.BeneficioLei1232006" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesLei1232006" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="row col-form-label">
              <label class="required float-left col-9">
                Há previsão de permissão de subcontratação?
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
                [(ngModel)]="arquivo.Subcontratacao" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
        <p-fieldset legend="Compras e Serviços de TI" *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'">
          <div class="row">
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  No pedido de compra, consta a finalidade da aquisição dos equipamentos?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.FinalidadeEquipamento" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido a necessidade de compatibilidade com os demais computadores e sistemas (parque de TI)
                  do órgão?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.CompatibilidadeCompuitadoresSistemas"
                  [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido substituição dos equipamentos antigos por novos e há justificativa adequada para tal
                  substituição?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.PedidoSubstituicaoEquipamentoAntigos"
                  [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido nomes e marcas de equipamentos?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.PedidoNomesMarcas" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido informações sobre descrição técnica dos equipamentos para sua finalidade de uso?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.DescricaoTecnica" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido a necessidade de software proprietário do mesmo fabricante do equipamento?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.SoftwareProprietario" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido a necessidade de manuais (impressos ou em mídia digital) em língua portuguesa?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.ManuaisEmPortugues" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
            <div class="col-6">
              <div class="row col-form-label">
                <label class="required float-left col-9">
                  Consta no pedido a exigência de certificação ou homologação da ANATEL?
                </label>
                <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="float-right col-3"
                  [(ngModel)]="arquivo.ComprasServicosTI.CertificadoANATEL" [ngModelOptions]="{standalone: true}">
                  <ng-template let-opcao>
                    <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>
          </div>
        </p-fieldset>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="pre-qualificacao" role="tabpanel" aria-labelledby="pre-qualificacao-tab"
      *ngIf="registroPreco === 'N' && (arquivo.modalidade === 1 || arquivo.modalidade === 2)">
      <lib-licitacao-audesp-prequalificacao [entidade]="arquivo">
      </lib-licitacao-audesp-prequalificacao>
    </div>
    <div class="tab-pane fade" id="lote-item" role="tabpanel" aria-labelledby="lote-item-tab">
      <lib-licitacao-audesp-lote [objeto]="arquivo.ComprasServicos" *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO'">
      </lib-licitacao-audesp-lote>
      <lib-licitacao-audesp-lote [objeto]="arquivo.ComprasServicosTI"
        *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'"></lib-licitacao-audesp-lote>
      <lib-licitacao-audesp-lote-eng [objeto]="arquivo.ObrasServicosEngenharia"
        *ngIf="arquivo.tipoObjeto === 'ENGENHARIA'"></lib-licitacao-audesp-lote-eng>
    </div>
    <div class="tab-pane fade" id="ratificacao" role="tabpanel" aria-labelledby="ratificacao-tab"
      *ngIf="arquivo.modalidade === 10 || arquivo.modalidade === 11">
      <p-fieldset legend="Publicação da ratificação">
        <div class="row col-form-label">
          <label class="required float-left col-3">
            Houve publicação do ato de ratificação da contratação direta?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.PublicacaoAtoRatificacaoNao.PublicacaoAtoRatificacao"
            [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
          <label class="required col-2 col-form-label"
            *ngIf="arquivo.PublicacaoAtoRatificacaoNao.PublicacaoAtoRatificacao === 'N'">
            Data da finalização do processo
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.PublicacaoAtoRatificacaoDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.PublicacaoAtoRatificacaoNao.PublicacaoAtoRatificacao === 'N'">
          </p-calendar>
          <label class="required col-2 col-form-label"
            *ngIf="arquivo.PublicacaoAtoRatificacaoNao.PublicacaoAtoRatificacao === 'S'">
            Data da publicação da ratificação
          </label>
          <p-calendar (onFocus)="onFocusDate()"
            [(ngModel)]="arquivo.PublicacaoAtoRatificacaoNao.DataFinalizacaoProcesso"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.PublicacaoAtoRatificacaoNao.PublicacaoAtoRatificacao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="declaracao-recursos" role="tabpanel" aria-labelledby="declaracao-recursos-tab">
      <lib-licitacao-audesp-declaracao-recurso [entidade]="arquivo">
      </lib-licitacao-audesp-declaracao-recurso>
    </div>
    <div class="tab-pane fade" id="lrf" role="tabpanel" aria-labelledby="lrf-tab">
      <lib-licitacao-audesp-lrf [entidade]="arquivo"></lib-licitacao-audesp-lrf>
    </div>
    <div class="tab-pane fade" id="parecer" role="tabpanel" aria-labelledby="parecer-tab">
      <lib-licitacao-audesp-parecer [entidade]="arquivo"></lib-licitacao-audesp-parecer>
    </div>
    <div class="tab-pane fade" id="edital" role="tabpanel" aria-labelledby="edital-tab"
      *ngIf="registroPreco === 'N' && arquivo.modalidade !== 2">
      <lib-licitacao-audesp-edital [entidade]="arquivo.ComprasServicos.Edital"
        *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO'"></lib-licitacao-audesp-edital>
      <lib-licitacao-audesp-edital [entidade]="arquivo.ComprasServicosTI.Edital"
        *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'"></lib-licitacao-audesp-edital>
    </div>
    <div class="tab-pane fade" id="edital-fase2" role="tabpanel" aria-labelledby="edital-fase2-tab"
      *ngIf="registroPreco === 'N' && arquivo.modalidade === 2">
      <lib-licitacao-audesp-edital-fase2 [entidade]="arquivo"></lib-licitacao-audesp-edital-fase2>
    </div>
    <div class="tab-pane fade" id="datas" role="tabpanel" aria-labelledby="datas-tab" *ngIf="registroPreco === 'N'">
      <p-fieldset legend="Data de entrega das propostas">
        <div class="row col-form-label">
          <label class="required float-left col-3">
            Houve Entrega de Propostas?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.DataEntregaPropostaNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
          <label class="required col-2 col-form-label" *ngIf="arquivo.DataEntregaPropostaNao === 'S'">
            Data
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.DatasEntregaPropostaDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.DataEntregaPropostaNao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
      <p-fieldset legend="Data de Abertura da Licitação">
        <div class="row col-form-label">
          <label class="required float-left col-3">
            Houve Entrega de Propostas?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.DatasAberturaLicitacaoNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
          <label class="required col-2 col-form-label" *ngIf="arquivo.DatasAberturaLicitacaoNao === 'S'">
            Data
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.DatasAberturaLicitacaoDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.DatasAberturaLicitacaoNao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
      <p-fieldset legend="Data de Julgamento">
        <div class="row col-form-label">
          <label class="required float-left col-3">
            Houve Entrega de Propostas?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.DatasJulgamentoNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
          <label class="required col-2 col-form-label" *ngIf="arquivo.DatasJulgamentoNao === 'S'">
            Data
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.DatasJulgamentoDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.DatasJulgamentoNao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="comissao" role="tabpanel" aria-labelledby="comissao-tab"
      *ngIf="registroPreco === 'N'">
      <lib-licitacao-audesp-comissao [entidade]="arquivo"></lib-licitacao-audesp-comissao>
    </div>
    <div class="tab-pane fade" id="licitantes" role="tabpanel" aria-labelledby="licitantes-tab">
      <lib-licitacao-audesp-licitante [entidade]="arquivo"></lib-licitacao-audesp-licitante>
    </div>
    <div class="tab-pane fade" id="atestado" role="tabpanel" aria-labelledby="atestado-tab"
      *ngIf="registroPreco === 'N'">
      <lib-licitacao-audesp-atestado [entidade]="arquivo"></lib-licitacao-audesp-atestado>
    </div>
    <div class="tab-pane fade" id="indice" role="tabpanel" aria-labelledby="indice-tab" *ngIf="registroPreco === 'N'">
      <lib-licitacao-audesp-indice [entidade]="arquivo"></lib-licitacao-audesp-indice>
    </div>
    <div class="tab-pane fade" id="amostras" role="tabpanel" aria-labelledby="amostras-tab">
      <lib-licitacao-audesp-amostra [objeto]="arquivo.ComprasServicos" *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO'">
      </lib-licitacao-audesp-amostra>
      <lib-licitacao-audesp-amostra [objeto]="arquivo.ComprasServicosTI"
        *ngIf="arquivo.tipoObjeto === 'COMPRA_SERVICO_TI'"></lib-licitacao-audesp-amostra>
    </div>
    <div class="tab-pane fade" id="visita" role="tabpanel" aria-labelledby="visita-tab">
      <lib-licitacao-audesp-visita [objeto]="arquivo.ObrasServicosEngenharia"
        *ngIf="arquivo.tipoObjeto === 'ENGENHARIA'"></lib-licitacao-audesp-visita>
    </div>
    <div class="tab-pane fade" id="tributos" role="tabpanel" aria-labelledby="tributos-tab"
      *ngIf="registroPreco === 'N'">
      <p-fieldset legend="Quitação de tributos">
        <div class="row col-form-label">
          <label class="required float-left col-9">
            Há exigência de prévia quitação de tributos pelos licitantes?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.TributosNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row" *ngIf="arquivo.TributosNao === 'S'">
          <div class="col-3">
            <div class="row col-form-label">
              <label class="required float-left col-6">
                Federais
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-6"
                [(ngModel)]="arquivo.TributosFederais" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-3">
            <div class="row col-form-label">
              <label class="required float-left col-6">
                Estaduais
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-6"
                [(ngModel)]="arquivo.TributosEstaduais" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
          <div class="col-3">
            <div class="row col-form-label">
              <label class="required float-left col-6">
                Municipais
              </label>
              <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-6"
                [(ngModel)]="arquivo.TributosMunicipais" [ngModelOptions]="{standalone: true}">
                <ng-template let-opcao>
                  <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="julgamento" role="tabpanel" aria-labelledby="julgamento-tab"
      *ngIf="registroPreco === 'N'">
      <lib-licitacao-audesp-julgamento [entidade]="arquivo"
        *ngIf="arquivo.modalidade !== 2 && arquivo.Lei13121 === 'N'">
      </lib-licitacao-audesp-julgamento>
      <lib-licitacao-audesp-julgamento-inversao [entidade]="arquivo"
        *ngIf="arquivo.modalidade !== 2 && arquivo.Lei13121 === 'S'">
      </lib-licitacao-audesp-julgamento-inversao>
      <lib-licitacao-audesp-julgamento-recebimento [entidade]="arquivo" *ngIf="arquivo.modalidade === 2">
      </lib-licitacao-audesp-julgamento-recebimento>
    </div>
    <div class="tab-pane fade" id="homologacao" role="tabpanel" aria-labelledby="homologacao-tab"
      *ngIf="registroPreco === 'N'">
      <p-fieldset legend="Homologação">
        <div class="row col-form-label">
          <label class="required float-left col-9">
            Há no procedimento comprovação da publicação da homologação?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.HomologacaoPublicacaoNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row col-form-label">
          <label class="required col-2 col-form-label" *ngIf="arquivo.HomologacaoPublicacaoNao === 'S'">
            Data
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.HomologacaoPublicacaoDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.HomologacaoPublicacaoNao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="adjudicacao" role="tabpanel" aria-labelledby="adjudicacao-tab"
      *ngIf="registroPreco === 'N'">
      <p-fieldset legend="Adjudicação">
        <div class="row col-form-label">
          <label class="required float-left col-9">
            Há no procedimento comprovação da publicação da adjudicação?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.AdjudicacaoNao" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row col-form-label">
          <label class="required col-2 col-form-label" *ngIf="arquivo.AdjudicacaoNao === 'S'">
            Data
          </label>
          <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="arquivo.AdjudicacaoDt"
            [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
            dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true"
            *ngIf="arquivo.AdjudicacaoNao === 'S'">
          </p-calendar>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="contratacao-direta" role="tabpanel" aria-labelledby="contratacao-direta-tab"
      *ngIf="arquivo.modalidade === 10 || arquivo.modalidade === 11">
      <p-fieldset legend="Contratação Direta">
        <div class="row col-form-label">
          <label class="required float-left col-3">
            Fundamento Legal
          </label>
          <select [compareWith]="compareFn" class="form-control col-6" [(ngModel)]="arquivo.FundamentoLei"
            [ngModelOptions]="{standalone: true}" *ngIf="arquivo.modalidade === 10">
            <option *ngFor="let item of opcoesFundamentoDispensa" [ngValue]="item.id">{{item.nome}}</option>
          </select>
          <select [compareWith]="compareFn" class="form-control col-6" [(ngModel)]="arquivo.FundamentoLei"
            [ngModelOptions]="{standalone: true}" *ngIf="arquivo.modalidade === 11">
            <option *ngFor="let item of opcoesFundamentoInexigibilidade" [ngValue]="item.id">{{item.nome}}</option>
          </select>
        </div>
        <div class="row col-form-label">
          <label class="required float-left col-8">
            Consta do procedimento justificativa para a contratação direta?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.ExisteJustificativaContratacaoDireta" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row col-form-label">
          <label class="required float-left col-8">
            Trata-se de contratação com fundamento no art. 83, IX, X, XI ou XII da Instrução 02/2016?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="float-right col-3"
            [(ngModel)]="arquivo.TrataContratacaoFundArt3Resolucao072014" [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
      </p-fieldset>
    </div>
    <div class="tab-pane fade" id="autorizacao" role="tabpanel" aria-labelledby="autorizacao-tab">
      <lib-licitacao-audesp-autorizacao [entidade]="arquivo" [registroPreco]="registroPreco">
      </lib-licitacao-audesp-autorizacao>
    </div>
  </div>
</p-fieldset>